import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { stringify } from 'query-string'
import { fetchEntryData, fetchEntryDataAsync, setEntryDataState } from '../../actions/app/entryData.actions'
import { ApiRequest } from '../../apiRequest'
import { getEntryApiUrl } from '../../../constants/apiUrls'
import initParametersSelector from '../../selectors/initParametersSelector'
import { fetchCarlineData } from '../../actions/app/carlineData.actions'
import { applyBrand } from '../../actions/app/brand.actions'
import { createNotification } from '../../actions/app/notification.actions'
import LinkData from '../../../entities/LinkData'
import { translateForDisplay } from '@avp/core'
import isOrderButtonEnabledSelector from '../../selectors/feature-scope/isOrderButtonEnabledSelector'
import isVwnRecommendationsEnabledSelector from '../../selectors/feature-scope/isVwnRecommendationsEnabledSelector'
import { fetchVwnModelsWithRecommendations } from '../../actions/app/vwnRecommendation.actions'
import { setBackgroundImageTypeState } from '../../actions/app/backgroundImageSwitcher.actions'
import { setCurrentBuildabilityType } from '../../actions/app/buildabilitySwitcher.actions'
import defaultBuildabilitySelector from '../../selectors/buildability/defaultBuildabilitySelector'
import isTrampolineEnabledSelector from '../../selectors/feature-scope/isTrampolineEnabledSelector'
import { configurationIsResetOnInit, resetConfiguration } from '../../actions/app/configuration.actions'

import { sessionIdManager } from '../../../utils/sessionIdManager'
import { loadConfigurationByVehicleCode } from '../../actions/app/vehicleCode.actions'

const noReturnUrl = (links: LinkData[]): boolean => {
    let result = true
    if (links) {
        links.forEach((link) => {
            if (link.id === 'orderUrl') {
                result = false
            }
        })
    }
    return result
}

// eslint-disable-next-line max-len
const entryDataMiddleware = (apiRequest: ApiRequest): Middleware => (store) => (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(fetchEntryData, action)) {
        const state = getState()
        const params = initParametersSelector(state)
        const paramsWithoutContextAndFeatures = {
            ...params,
        }

        delete paramsWithoutContextAndFeatures.contextId
        delete paramsWithoutContextAndFeatures.features
        delete paramsWithoutContextAndFeatures.entryUrl

        const requestParams = stringify(paramsWithoutContextAndFeatures, {
            skipNull: true,
        })

        apiRequest({
            options: {
                url: getEntryApiUrl(params.contextId, requestParams),
                method: 'GET',
            },
            asyncActions: fetchEntryDataAsync,
            causedBy: action,
        }, dispatch)
    }

    if (isActionOf(fetchEntryDataAsync.success, action)) {
        if (action.payload?.sessionId) {
            sessionIdManager.set(action.payload.sessionId)
        }

        if (action.payload?.featureScopes?.includes('clearOnInit')) {
            dispatch(resetConfiguration(undefined, {
                onSuccess: configurationIsResetOnInit,
                onFailure: configurationIsResetOnInit,
            }))
        }

        dispatch(setEntryDataState(action.payload))

        const state = getState()
        const backgroundImageType = action.payload?.renderImagesOrdering?.[0] ?? 'DEFAULT'
        const defaultBuildabilityType = defaultBuildabilitySelector(state)
        const isOrderButtonEnabled = isOrderButtonEnabledSelector(state)
        const isTrampolineEnabled = isTrampolineEnabledSelector(state)
        const isVwnRecommendationsEnabled = isVwnRecommendationsEnabledSelector(state)

        //FONG only
        const configurationIdentifier = action.payload?.configurationIdentifier

        dispatch(setCurrentBuildabilityType(defaultBuildabilityType))
        dispatch(setBackgroundImageTypeState(backgroundImageType))
        dispatch(applyBrand())
        dispatch(fetchCarlineData())
        if(action.payload){
            if(isOrderButtonEnabled && noReturnUrl(action.payload.links) && !isTrampolineEnabled){
                dispatch(createNotification({
                    type: 'error',
                    message: translateForDisplay('notifications.no-return-url'),
                }))
            }
        }

        if (isVwnRecommendationsEnabled) {
            dispatch(fetchVwnModelsWithRecommendations())
        }

        //FONG only
        if(configurationIdentifier) {
            dispatch(loadConfigurationByVehicleCode(configurationIdentifier))
        }
    }
}

export default entryDataMiddleware
